import { render, staticRenderFns } from "./Sound.vue?vue&type=template&id=367ef202&scoped=true&"
import script from "./Sound.vue?vue&type=script&lang=js&"
export * from "./Sound.vue?vue&type=script&lang=js&"
import style0 from "./Sound.vue?vue&type=style&index=0&id=367ef202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ef202",
  null
  
)

export default component.exports